module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6cdd205c5e99bf7808ab16e73817b74.png";